import { Phone, MessageCircle } from "lucide-react";
import { telHref, waHref } from "@/lib/brand";

export default function FloatingActions() {
    return (
        <div
            data-testid="floating-actions"
            className="fixed bottom-5 right-5 z-50 flex flex-col gap-3"
        >
            <a
                href={waHref}
                target="_blank"
                rel="noreferrer"
                data-testid="floating-whatsapp"
                aria-label="WhatsApp"
                className="w-14 h-14 bg-green-500 hover:bg-green-400 rounded-full flex items-center justify-center shadow-[0_8px_24px_rgba(34,197,94,0.45)] transition-transform hover:scale-110"
            >
                <MessageCircle className="w-6 h-6 text-white" />
            </a>
            <a
                href={telHref}
                data-testid="floating-call"
                aria-label="Call"
                className="w-14 h-14 bg-[#1E88E5] hover:bg-[#1976D2] rounded-full flex items-center justify-center shadow-[0_8px_24px_rgba(30,136,229,0.45)] transition-transform hover:scale-110 pulse-blue"
            >
                <Phone className="w-6 h-6 text-white" />
            </a>
        </div>
    );
}
